import React, { useEffect, useMemo, useState } from 'react'
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core'

export default function MaterialGroupSelectDialog({ open, setOpen, data = [], onSave, title = 'Agrupaciones de materiales', multiple = true }) {
	const [query, setQuery] = useState('')
	const [selected, setSelected] = useState([])
	useEffect(() => { if (open) { setQuery(''); setSelected([]) } }, [open])
	const rows = useMemo(() => data.filter(x => x.activo && `${x.referencia || ''} ${x.descripcion || ''}`.toLowerCase().includes(query.toLowerCase())), [data, query])
	const toggle = (id) => setSelected(current => multiple ? (current.includes(id) ? current.filter(x => x !== id) : [...current, id]) : [id])
	return <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
		<DialogTitle>{title}</DialogTitle>
		<DialogContent dividers>
			<TextField fullWidth label="Buscar" value={query} onChange={e => setQuery(e.target.value)} margin="dense" />
			<div className="mt-3">
				{rows.map(group => <button key={group.id} type="button" onClick={() => toggle(group.id)} className="w-100 text-left border-0 p-3 mb-2" style={{ background: selected.includes(group.id) ? '#e8f0ff' : '#f7f9fc' }}>
					<Checkbox checked={selected.includes(group.id)} color="primary" />
					<strong>{group.descripcion}</strong>{group.referencia ? ` · ${group.referencia}` : ''}
					<span className="text-muted ml-3">{(group.productos || []).length} materiales</span>
				</button>)}
				{!rows.length && <div className="text-muted p-3">No hay agrupaciones disponibles.</div>}
			</div>
		</DialogContent>
		<DialogActions><Button onClick={() => setOpen(false)}>Cancelar</Button><Button color="primary" variant="contained" disabled={!selected.length} onClick={() => { onSave(multiple ? selected : selected[0]); setOpen(false) }}>Añadir</Button></DialogActions>
	</Dialog>
}
